// Comparador único para ordenar modelos: pendientes primero, luego completados/liberados,
// y depurados al final; dentro de cada grupo, por nombre A-Z (locale es).
// Reutilizado por la tabla de ColeccionDetalle y por las flechas de navegación de ModeloDetalle
// para que el recorrido coincida exactamente con el orden de la tabla.
export function compararModelos(a, b) {
  const ga = a.depurado ? 2 : a.estatus?.completo ? 1 : 0;
  const gb = b.depurado ? 2 : b.estatus?.completo ? 1 : 0;
  if (ga !== gb) return ga - gb;
  return (a.nombre || "").localeCompare(b.nombre || "", "es", { sensitivity: "base" });
}
